export default __webpack_public_path__ + "static/media/Q_Matting.a0ef238e.jpg";